import { useAppContext } from '../../appProvider/contextProvider';
import UpgradeBG from '../../assets/images/UpgradePage.png';
import { BASIC_PLAN, PAID_DESCRIPTION } from '../../constants/AppConstants';

const PremiumComponent = ({keyword, title}) => {

    const { setPricingPopupOpen,  selectedWebsite, planDetails } = useAppContext();



    return (!!selectedWebsite && !!planDetails) && <div className ="panel full-height">
        <div className="d-flex full-height">
            <div className="d-flex p-5 text-center full-width flex-column justify-content-center align-items-center">
                <h4 className="mb-2" >{title || 'Premium Component'}</h4>
                <span className="mb-4" >{PAID_DESCRIPTION[keyword] || ''}</span>
                <button onClick={() => setPricingPopupOpen(true)} className="btn btn-primary titleCase mb-3">Upgrade to premium</button>
                <small className="txt-primary" >{BASIC_PLAN()}</small>
            </div>
            <img src={UpgradeBG} className="d-none d-lg-block" alt="upgrade"/>
        </div>
    </div> 
}

export default PremiumComponent;